/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCancelInboundPlanRequest
 */
export interface RequestCancelInboundPlanRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestCancelInboundPlanRequest
     */
    id: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof RequestCancelInboundPlanRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestCancelInboundPlanRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestCancelInboundPlanRequest interface.
 */
export function instanceOfRequestCancelInboundPlanRequest(value: object): value is RequestCancelInboundPlanRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RequestCancelInboundPlanRequestFromJSON(json: any): RequestCancelInboundPlanRequest {
    return RequestCancelInboundPlanRequestFromJSONTyped(json, false);
}

export function RequestCancelInboundPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCancelInboundPlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestCancelInboundPlanRequestToJSON(json: any): RequestCancelInboundPlanRequest {
    return RequestCancelInboundPlanRequestToJSONTyped(json, false);
}

export function RequestCancelInboundPlanRequestToJSONTyped(value?: RequestCancelInboundPlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

